import React from 'react'
import { PersonalPrelevementInfoModel, PrelevementModel, ProfileShortModel, SignResponseModel } from '../profileModel'

export const initPersonalInfo = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    street: '',
    postalCode: '',
    city: '',
    country: ''
}

export const prelevement: PrelevementModel = {
    propertyConcerned: [],
    personalInfo: initPersonalInfo,
    financialInfo: {
        iban: '',
        bic: '',
        rib: {
            file: '',
            encodedFile: ''
        }
    }
}

const userDetails: ProfileShortModel = {
    email: '',
    phone: null
}

export const PrelevementContext = React.createContext({
        prelevement: prelevement,
        userDetails: userDetails,
        step: 1,
        previousStep: () => {
        },
        nextStep: (signResponse?: SignResponseModel) => {
        },
        closeDialog: () => {
        },
        resetStep: () => {
        },
        setPersonalInfo : (info: PersonalPrelevementInfoModel) => {}
    }
)
